module.exports = __webpack_public_path__ + "img/6.09e93043.png";